export default __webpack_public_path__ + "static/vision-3020-031-db368dbc572e8947387b3ad3e09f5101.png";